import AdminUser from "@/pages/admin/User/AdminUser";
import AdminSettings from "@/pages/admin/setting/AdminSettings";
import Sentry from "@/pages/dashboard/Sentry/Sentry";
import Asset from "@/pages/dashboard/Asset/Asset";
import Analytics from "@/pages/dashboard/analytics/Analytics";
import BYOD from "@/pages/dashboard/byod/BYOD";
import Issuer from "@/pages/dashboard/issuer/Issuer";
import Prices from "@/pages/dashboard/prices/Prices";
import PricesDetailsPage from "@/pages/dashboard/prices/details-page/PricesDetailsPage";

export const route = [

    {
        path: "/sentry",
        ele: <Sentry />,
        permission: 'user',
    },
    {
        path: "/data/asset",
        ele: <Asset />,
        permission: 'user',
    },
    {
        path: "/data/issuer",
        ele: <Issuer />,
        permission: 'user',
    },

    {
        path: "/data/analytics",
        ele: <Analytics />,
        permission: 'user',
    },
    {
        path: "/data/prices",
        ele: <Prices />,
        permission: 'user',
    },
    {
        path: "/data/prices/:slug",
        ele: <PricesDetailsPage />,
        permission: 'user',
    },
    {
        path: "/data/BYOD",
        ele: <BYOD />,
        permission: 'user',
    },
    // admin Routes
    {
        path: "/admin/user",

        ele: <AdminUser />,
        permission: 'admin',
    },
    {
        path: "/admin/account/setting",
        ele: <AdminSettings />,
        permission: 'admin',
    },
]